<template>
<div id="article-container">
    <section class='article-list' v-for="article in articles">
        <h1 class="title" v-text="article.title"></h1>
        <div class="main-content" >
            <div class="description" v-text="article.description">
            </div>
        </div>
        <div class='more'>
            <router-link :to="article.url">More</router-link>
        </div>
        <!-- <div class="copyRight">
            <span v-text="article.createTime"></span>
            <span v-text="article.author"></span>
        </div> -->
    </section>

</div>
</template>

<script>
export default {
    data() {
        return {
            articles: [],
            title: '',
            isLoading: true,
            disable: true
        }
    },
    methods: {

    },
    mounted() {
        this.$http.get('../static/article-list.json', {}, {
            headers: {},
            emulateJSON: true
        }).then(function(response) {
            // 这里是处理正确的回调
            console.log(response);
            this.articles = response.body;
        }, function(response) {
            // 这里是处理错误的回调
            console.log(response)
        });

    },


}
</script>
<style lang='scss'>
@mixin inlineTop {
    display: inline-block;
    vertical-align: top;
}
// section
.article-list {
    width: 80%;
    margin: 0 auto 50px;
    overflow: auto;
    text-align: left;
    .title {
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
    }
    .main-content {
        width: 90%;
    }
    .description {
        padding:15px 5px;
    }
    .copyRight,.more{
        text-align: right;
        padding-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// articleList.vue?6decb8b1